import { Injectable } from '@angular/core';
import {
  DOMAIN_PROD_URL,
  NuTRAVEL_ADMIN_ACTION_DEV_URL,
  NuTRAVEL_ADMIN_ACTION_PROD_URL,
  PERM_TYPE,
  SKYBONUS_DEV_URL,
  SKYBONUS_PROD_URL
} from '../../constants/profile-selector/profile-selector-constants';
import {
  DashboardDataResponse,
  loginAndGetDashboardResponse
} from '../../models/login';
import { ProfileTypes } from '../../models/profile-selector/nuTravel.interface';
import { ProfileSelectorFacadeBaseService } from './profile-selector-facade-base.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorFacadeHelperService extends ProfileSelectorFacadeBaseService {
  assignQueryParams(queryParams: { [key: string]: string }): void {
    this.queryParams = queryParams;
    this.queryParamKeys = Object.keys(queryParams);
    this.paramsToIgnore = [
      'login_tokenId',
      'login_username',
      'login_lastName',
      'login_password',
      'login_refreshURL',
      'refreshURL',
      'login_isPersistent',
      'login_reasonCode',
      'login_maskedEmail'
    ];
    this.refreshURL = this.getRefreshURL(this.refreshURL);
  }

  // eslint-disable-next-line complexity
  getRefreshURL(refreshURL: string): string {
    const contextRoot = '/home';
    const homePageUrl = '/';
    if (
      refreshURL &&
      refreshURL !== '' &&
      refreshURL !== 'null' &&
      refreshURL !== null &&
      refreshURL.indexOf(contextRoot) === -1
    ) {
      return refreshURL;
    }
    return homePageUrl;
  }

  logout(): void {
    this.logOut.logOut();
  }

  sendFormPostRequest(permType: string, companyName: string): void {
    this.skyBonusNuTravelAdapterService.setCompanySelected(
      this.profileSelectorUtilService.transformCompanyNameFont(companyName)
    );
    const payload = this.skyBonusNuTravelAdapterService.getNuTravelObject();
    if (permType === PERM_TYPE.A) {
      this.createDynamicForm(
        'profileSelector',
        payload,
        this.setActionFormPostURL()
      );
    }

    if (permType === PERM_TYPE.S) {
      this.createDynamicForm('profileSelector', payload, '');
    }
  }

  createDynamicForm(name: string, value: ProfileTypes[], action: string): void {
    const stringfyPayload = JSON.stringify(value);
    const form = document.createElement('form');
    form.action = action;
    form.method = 'post';
    const input = document.createElement('input');
    input.name = name;
    input.value = stringfyPayload;
    input.type = 'hidden';
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  setActionFormPostURL(): string {
    const environment = window.location.origin;

    if (environment === DOMAIN_PROD_URL) {
      return (
        this.profileSelectorAdapterService.url.nuTravelLoginActionUrl_Prod ??
        NuTRAVEL_ADMIN_ACTION_PROD_URL
      );
    } else {
      return (
        this.profileSelectorAdapterService.url.nuTravelLoginActionUrl_Dev ??
        NuTRAVEL_ADMIN_ACTION_DEV_URL
      );
    }
  }

  redirectToSKyBonusPath(): string {
    const environment = window.location.origin;

    if (environment === DOMAIN_PROD_URL) {
      return (
        this.profileSelectorAdapterService.url.permType_S ?? SKYBONUS_PROD_URL
      );
    } else {
      return (
        this.profileSelectorAdapterService.url.permType_S_Dev ??
        SKYBONUS_DEV_URL
      );
    }
  }

  setLoginStatus(
    res: loginAndGetDashboardResponse | DashboardDataResponse
  ): void {
    this.isLoggedInStatus$.next(res.loggedIn || res.isWarmState);
    this.isDashBoardResponse$.next(true);
    this.dashboardData = res;
  }
}
